import Vue from 'vue'
import Router from 'vue-router'
import Cookie from 'js-cookie';

import SignIn from '@/components/SignIn'
import Account from '@/components/Account'
import Users from '@/components/Users'
import UserDetails from '@/components/UserDetails'
import Listings from '@/components/Listings'
import ListingDetails from '@/components/ListingDetails'
import BuyerComparison from '@/components/BuyerComparison'
import Projects from '@/components/Projects'
import PrintablePsrReport from '@/components/ProjectReport'
import Reports from '@/components/Reports'
import EMPReports from '@/components/ReportsEMP'
import DataManagement from '@/components/DataManagement'
import NotFound from '@/components/404'
import FormFieldDetails from '@/components/FormFieldDetails'
import Modules from '@/components/Modules'
import TaskDashboard from '@/components/TaskDashboard'
import ChartDashboard from '@/components/ChartDashboard'

//import Buyer from '@/components/Buyer'

Vue.use(Router)

const ifAuthenticated = (to, from, next) => {
  if (Cookie.get('token')) {
    next()
    return
  }
  next('/login')
}
const ifNotAuthenticated = (to, from, next) => {
  if (!Cookie.get('token')) {
    next()
    return
  }
  next()
}

export default new Router({
  mode: 'history',
  routes: [
    {
      path: "/login",
      name: "login",
      component: SignIn,
      beforeEnter: ifNotAuthenticated,
    },
    {
      path: "/account",
      name: "account",
      component: Account,
      beforeEnter: ifAuthenticated,
    },
    {
      path: "/users",
      name: "users",
      component: Users,
      beforeEnter: ifAuthenticated,
    },
    {
      path: "/user_details/:uid",
      name: "user_details",
      component: UserDetails,
      beforeEnter: ifAuthenticated,
    },
    {
      path: "/listings",
      name: "listings",
      component: Listings,
      beforeEnter: ifAuthenticated,
    },
    {
      path: "/listing_details/:lid",
      name: "listing_details",
      component: ListingDetails,
      beforeEnter: ifAuthenticated,
    },
    {
      path: "/listing_buyers/:lid",
      name: "listing_buyers",
      component: BuyerComparison,
      beforeEnter: ifAuthenticated,
    },
    {
      path: "/reports",
      name: "reports",
      component: Reports,
      beforeEnter: ifAuthenticated,
    },
    {
      path: "/emp_reports",
      name: "emp_reports",
      component: EMPReports,
      beforeEnter: ifAuthenticated,
    },
    {
      path: "/datamanagement",
      name: "datamanagement",
      component: DataManagement,
      beforeEnter: ifAuthenticated,
    },
    {
      path: "/datamanagement/:listName",
      name: "datamanagementlist",
      component: DataManagement,
      beforeEnter: ifAuthenticated,
    },
    {
      path: "/new_form_field/:listName",
      name: "createformfield",
      component: FormFieldDetails,
      beforeEnter: ifAuthenticated,
    },
    {
      path: "/form_field_details/:lid",
      name: "updateformfield",
      component: FormFieldDetails,
      beforeEnter: ifAuthenticated,
    },
    {
      path: "/modules",
      name: "modules",
      component: Modules,
      beforeEnter: ifAuthenticated,
    },
    {
      path: "/projects",
      name: "projects",
      component: Projects,
      beforeEnter: ifAuthenticated,
    },
    {
      path: "/task_dashboard",
      name: "task_dashboard",
      component: TaskDashboard,
      beforeEnter: ifAuthenticated,
    },
    {
      path: "/chart_dashboard",
      name: "chart_dashboard",
      component: ChartDashboard,
      beforeEnter: ifAuthenticated,
    },
    {
      path: "/:pid/printable_psr_report",
      name: "printable_psr_report",
      component: PrintablePsrReport,
      beforeEnter: ifAuthenticated,
    },
    {
      path: "/*",
      component: NotFound,
      beforeEnter: ifAuthenticated,
    }
  ]
})


// WEBPACK FOOTER //
// ./src/router/index.js